import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { SalesmanApi } from "@/services/Api";
import { PropType, ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LinkBoxWrapper',
  props: {
  salesman: {
    type: Object as PropType<any>,
    required: true,
  },
  postalCode: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;


const salesmanInput = ref<string | undefined>(props.postalCode);
const salesman = ref<any>(JSON.parse(props.salesman));
const error = ref<string>();
const salesmanButtonDisabled = ref<boolean>(false);
const getSalesman = async (postalCode: string) => {
  try {
    salesmanInput.value = postalCode;
    salesmanButtonDisabled.value = true;
    error.value = undefined;
    salesman.value = await SalesmanApi.setPostalCookieAndGetSalesman(postalCode);
  } catch (e: any) {
    error.value = e;
  } finally {
    salesmanButtonDisabled.value = false;
  }
};
const onGetSalesmanSubmit = async (values) => {
  await getSalesman(values.postalCode);
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    onGetSalesmanSubmit: onGetSalesmanSubmit,
    salemanButtonDisabled: salesmanButtonDisabled.value,
    error: error.value,
    salesman: salesman.value,
    salesmanInput: salesmanInput.value
  })
}
}

})